module.exports = __webpack_public_path__ + "img/icon.68330e15.png";